export const profileSyncLanguages = {
    templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/user/components/profileSyncLanguages.html',
    bindings: {
        title: '@',
        languages: '<',
    },
};
